<template>
  <SingleColumn>
    <template #header>
      <h1 class="text-3xl font-bold text-white">
        Podcast löschen
      </h1>
    </template>
    <template #content>
      <div class="bg-white shadow overflow-hidden sm:rounded-md">
        <div class="py-6 px-4 sm:p-6 lg:pb-8">
          <span>
            Bist du sicher, dass du diesen Podcast aus dem St. Audio Studio löschen möchtest? Damit gehen alle Experimente und Metriken verloren und ein zugewiesener Pro-Plan wird entkoppelt. Wenn du die Aktion tatsächlich durchführen möchtest, bestätige bitte mit deinem aktuellen Passwort.
          </span>
          <DeletionForm :resource="resource" :errors="errors" />
        </div>
        <div class="px-6 pb-6 divide-y divide-gray-200">
          <div class="flex justify-end">
            <DeleteButton @click="onSubmit">
              Podcast unwiderruflich löschen
            </DeleteButton>
          </div>
        </div>
      </div>
    </template>
  </SingleColumn>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useRemoveResource } from '@/client/actions';

const store = useStore();
const router = useRouter();

const parent = computed(() => store.getters['context/context'].id);
const target = computed(() => '/api/podcasts/' + parent.value);

const action = useRemoveResource(target, {password: null});

const { resource, errors, message, remove, removing } = action;

const reload = () => store.dispatch('context/setup');
const redirect = () => router.push({name: 'podcast.show'});

const onSubmit = () => remove(onSuccess);
const onSuccess = () => reload().then(redirect);
</script>
